/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Sell from "./Sell";

/* Render Sell app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<Sell {...props} />, document.getElementById("react"));
}
render(window.reactProps);
